// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .1s}.fade-enter,.fade-leave-to{opacity:0}", ""]);
// Exports
module.exports = exports;
